export enum OrderStatus {
    INITIATED = 'initiated',
    PAID = 'paid',
    SUBSCRIPTION_OPEN = 'subscription_open',
    CANCELLED = 'cancelled',
    FAILED = 'failed',
}